import { Outlet } from 'react-router-dom';
import { AppSidebar } from '@/components/app-sidebar/AppSidebar';
import { SIDEBAR_STATE_STORAGE_KEY } from '@/components/app-sidebar/constants';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';

export const Layout = () => {
  const initialOpen = localStorage.getItem(SIDEBAR_STATE_STORAGE_KEY) !== 'false';

  return (
    <SidebarProvider defaultOpen={initialOpen}>
      <AppSidebar />
      <SidebarInset>
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
};
